import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "sync"
const SyncIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.834 6.166C19.076 7.408 19.89 9.013 20.155 10.748 20.422 12.483 20.128 14.258 19.316 15.815 18.504 17.37 17.216 18.628 15.641 19.403 14.595 19.918 13.456 20.2 12.303 20.243L14.03 21.97 12.97 23.03 9.44 19.5 12.97 15.97 14.03 17.03 12.318 18.741C13.238 18.698 14.144 18.468 14.98 18.057 16.27 17.423 17.322 16.394 17.986 15.121 18.65 13.847 18.89 12.395 18.672 10.975S17.79 8.242 16.774 7.227zM14.56 4.5 11.405 7.655 10.345 6.595 11.68 5.258C10.763 5.302 9.857 5.532 9.022 5.943 7.732 6.577 6.68 7.606 6.014 8.879 5.351 10.153 5.11 11.605 5.328 13.025S6.211 15.758 7.227 16.773L6.167 17.833C4.924 16.594 4.111 14.989 3.844 13.254 3.579 11.516 3.873 9.742 4.685 8.185S6.783 5.37 8.358 4.596C9.405 4.083 10.543 3.8 11.696 3.757L10.345 2.407 11.405 1.344z" />
        </svg>
      }
    </span>
  )
}
export default SyncIcon
